/**
 * Small external-link affordance used across dashboard rows to deep-link into
 * Stripe / HubSpot. Renders as an unobtrusive icon link that opens in a new tab.
 *
 * `label` is the VISIBLE text (usually the id, e.g. the Stripe customer id or
 * HubSpot object id). `title` is the HOVER tooltip (e.g. "View in Stripe" /
 * "View in HubSpot"). Keeping them separate lets the row show the id while the
 * tooltip tells the admin what clicking will do.
 *
 * Uses target="_blank" + rel="noreferrer" (the opener is cross-origin; we
 * don't need window.opener access and noreferrer avoids leaking the referrer
 * to the vendor dashboard).
 */
export function ExtLink({
  href,
  label,
  title,
}: {
  href: string;
  label: string;
  title?: string;
}) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      className="inline-flex items-center gap-1 text-xs text-brand-600 hover:text-brand-700 hover:underline"
      title={title ?? label}
    >
      {label}
      <svg
        className="h-3 w-3"
        viewBox="0 0 20 20"
        fill="currentColor"
        aria-hidden="true"
      >
        <path d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z" />
        <path d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z" />
      </svg>
    </a>
  );
}
